import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center transition-opacity hover:opacity-80">
            <img
              src={
                isScrolled
                  ? "https://customer-assets.emergentagent.com/job_deslumbrangulo-smart/artifacts/guxrd2ji_Black%20logo%20-%20no%20background.png"
                  : "https://customer-assets.emergentagent.com/job_deslumbrangulo-smart/artifacts/f8ecyy7b_White%20logo%20-%20no%20background.png"
              }
              alt="Deslumbrângulo"
              className="h-10"
            />
          </Link>
        </div>
      </div>
    </header>
  );
};
